import {
    type FC
} from "react";
import {
    View
} from "react-native";
import type ISidebarHeaderProps from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import {
    useSidebarRootContext
} from "../../context";
import {
    getSidebarMeasures
} from "../../stylesheet";

const SidebarHeader: FC<ISidebarHeaderProps> = ({
    customTheme: customThemeProp,
    children,
    style,
    ...props
}) => {
    const root = useSidebarRootContext({
        part: "Sidebar.Header"
    });

    const customTheme = customThemeProp ?? root?.customTheme;

    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        borders,
        colors,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const measures = getSidebarMeasures({
        controlPaddings,
        controlHeights,
        shapeConfigs,
        spaces
    });

    const {
        container: containerDynamicStyle
    } = useStyles({
        isScrolled: root?.isScrolled ?? false,
        variant: root?.variant ?? "sidebar",
        measures,
        borders,
        colors,
        spaces
    });

    return <View
        {...props}
        style={[
            style,
            stylesheet.container,
            containerDynamicStyle
        ]}
    >
        {children}
    </View>;
};
export default SidebarHeader;
